import type { SVGProps } from "react";
// generated from Download.svg — do not edit manually
// prettier-ignore
export default function Download(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 21 22 H 3 M 18 12 L 12 18 M 12 18 L 6 12 M 12 18 V 3" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
